import { render, staticRenderFns } from "./EmailTemplateEdit.vue?vue&type=template&id=a81a89e2&scoped=true&"
import script from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateEdit.vue?vue&type=style&index=0&id=a81a89e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81a89e2",
  null
  
)

export default component.exports